/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { Ellipsis } from 'components/Ellipsis'
import iconBalloonUpdates from 'images/contextual-help-card/icon-balloon-updates.svg'
import { useState } from 'react'

interface ContextualHelpCardProps {
  title: string
  description: React.ReactNode
  image?: string
}

export function ContextualHelpCard(props: Readonly<ContextualHelpCardProps>) {
  const { title, description, image = iconBalloonUpdates } = props
  const theme = useTheme()
  const styles = createStyles(theme)
  const [isVisible, setIsVisible] = useState(true)
  const [verMais, setVerMais] = useState(false)

  if (!isVisible) return null

  return (
    <Box style={styles.box}>
      <div css={styles.closeButton}>
        <Button skin='ghost' size='small' onClick={() => setIsVisible(false)}>
          <Icon icon='timesDefault' />
        </Button>
      </div>

      <HFlow hSpacing={0.5}>
        <img src={image} alt='Contextual help' />

        <VFlow vSpacing={0.25}>
          <Heading level={4}>{title}</Heading>

          {verMais ? (
            <Text>{description}</Text>
          ) : (
            <Ellipsis showTooltip={false} maxLines={1}>
              {description}
            </Ellipsis>
          )}

          <Button skin='ghost' size='small' kind='primary' onClick={() => setVerMais(!verMais)}>
            <Text color='primary'>{verMais ? 'Ver menos' : 'Ver mais'}</Text>
          </Button>
        </VFlow>
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    width: 100%;
    border: 1px solid ${theme.pallete.gray.c80};
    border-radius: 6px;
    padding: 0.5rem;
    padding-right: 2.5rem;
    position: relative;
  `,
  closeButton: css`
    position: absolute;
    top: 0;
    right: 0;
  `,
})
